import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Action, ActionStatus, FormField, StrictFormDefinition } from '@/application/types';
import { showError } from '@/application/snackbar/service';
import { emailRule, passwordRule, requiredRule } from '@/helpers/form-rules';
import { LoginCommand } from '../../types';

const authenticationState = namespace('authentication');

interface Form extends StrictFormDefinition {
  fields: {
    email: FormField<string>;
    password: FormField<string>;
  }
}

@Component
export default class Login extends Vue {

  @authenticationState.Action
  login!: Action<LoginCommand>;

  @authenticationState.State
  isAuthenticated!: boolean;

  @authenticationState.State
  loginStatus!: ActionStatus;

  form: Form = {
    valid: false,
    fields: {
      email: {
        value: '',
        rules: [
          requiredRule(),
          emailRule(),
        ],
      },
      password: {
        value: '',
        rules: [
          requiredRule(),
          passwordRule(),
        ],
      },
    },
  };

  get isProcessing(): boolean {
    return this.loginStatus === ActionStatus.InProgress;
  }

  get isSubmitAllowed(): boolean {
    return !this.isProcessing && this.form.valid;
  }

  mounted() {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'default' });
    }
  }

  public onSubmit() {
    const command: LoginCommand = {
      email: this.form.fields.email.value,
      password: this.form.fields.password.value
    };

    this.login(command)
      .then(() => {
        this.$router.push({ name: 'default' });
      })
      .catch((error) => {
        // Don't show a message for disabled user as this is already done by the authentication interceptor
        if (error.response?.data.identifier !== 'user-disabled') {
          const message = error.response?.data.message || 'Die Anmeldung ist fehlgeschlagen';
          showError({ message });
        }
      });
  }

}
